import {USER_TYPES} from '../AppConstants/UserConstants';

/**
 * User types allowed to use the Smart Dining admin dashboard.
 * Aligns with backend admin auth (`/auth/v1/admins/*`) and `getAuthenticatedUser`.
 *
 * **Sales & support** are not separate `USER_TYPES`: use `ACCOUNT_MANAGER` with platform `Role` templates
 * (e.g. bootstrap “Account Representative”) or custom IAM policies. `SUPER_USER` with `platformRoleId` is full admin.
 */
export const ADMIN_PORTAL_USER_TYPES: readonly USER_TYPES[] = [
  USER_TYPES.SUPER_USER,
  USER_TYPES.ACCOUNT_MANAGER,
];

export function isAdminPortalUserType(userType: string | undefined | null): userType is USER_TYPES {
  if (userType === undefined || userType === null) {
    return false;
  }
  const s = String(userType).trim();
  return (ADMIN_PORTAL_USER_TYPES as readonly string[]).includes(s);
}
